<!--
 * @Author: 李朋飞
 * @Date: 2023-07-18 10:32:09
 * @LastEditTime: 2024-04-29 17:45:38
 * @FilePath: \tj\src\components\UploadPanel\index.vue
 * @Description:
-->
<template>
  <div style="overflow: hidden" v-loading.fullscreen="loading">
    <div class="Upload" :style="uploadType == 'importProject' ? 'display:none' : ''">
      <div
        v-if="uploadFilesBtn === false"
        class="Upload_item"
        :style="uploadType == 'uploadImg' ? 'width: 180px;height:170px' : 'width: 190px;height:190px'"
        v-for="(item, index) in uploadList"
        :key="index"
      >
        <div class="Upload_item_main"
          :style="uploadType == 'uploadImg' ? 'width: 180px;height:140px' : 'width: 190px;height:190px'"
        >
          <el-progress v-if="item.url == ''" style="color:#FFF;" color="#3171F2" indeterminate type="circle" :percentage="parseInt(item.progress*100)" />
          <div class="Upload_item_button_wrapper" v-if="item.url == ''">
            <div class="Upload_item_button">
              <el-button type="warning" v-if="!item.stop" @click="stopUpload(item, index)" link>暂停</el-button>
              <el-button type="success" @click="continueUpload(item, index)" v-else link>上传</el-button>
              <el-button type="danger" @click="cancelUpload(item, index)" link>取消</el-button>
            </div>
          </div>
          <el-image
            class="Upload_item_img"
            v-if="item.url != '' && /\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url)"
            :key="index"
            :src="ossDomain+item.url"
            :preview-src-list="uploadListShow"
            :initial-index="index"
            fit="cover"
          />
          <video v-else-if="item.url != '' && /\.mp4$/i.test(item.url)" :src="ossDomain+item.url" controls="controls" style="max-width: 100%; max-height: 100%;vertical-align: middle;">
            您的浏览器不支持 video 标签。
          </video>
          <div
            v-else-if="item.url != ''"
            class="l_UploadImages_file_file_icon"
            :style="{
              background:fileBack[(item.url.split('.')[item.url.split('.').length-1]).substring(0,1).charCodeAt()%5],
            }"
          >
            {{(item.url.split('.')[item.url.split('.').length-1]).substring(0,1).toUpperCase()}}
          </div>
          <div v-if="item.url != '' && uploadType != 'showFile'" class="Upload_item_delbutton_wrapper">
            <!-- <Delete @click="deleteItem(index)" style="width: 30px;color: #E42121;cursor: pointer;"/> -->
            <img src="@/assets/zgdelete.png" @click="deleteItem(index)" style="cursor: pointer;"/>
          </div>
          <div v-if="item.url != ''" class="Upload_item_dowbutton_wrapper">
            <a
            :href="ossDomain+item.url"
            :name="item.name"
            :download="item.name"
            target='_blank'
          >
            <!-- <Download style="width: 30px;color: #13B865;cursor: pointer;"/> -->
          </a>
          <!-- <img src="@/assets/is_top.png" @click="downloadItem(item)" style="cursor: pointer;"/> -->
            <!-- <Download @click="downloadItem(item)" style="width: 30px;color: #13B865;cursor: pointer;"/> -->
          </div>
        </div>
        <div class="Upload_item_footer">
          {{item.name}}
        </div>
      </div>
      <div
        v-show="localFiles && uploadFilesBtn == false"
        :class="disabled ? 'Upload_item_upload Upload_item_upload_disabled' : 'Upload_item_upload' "
        :style="uploadType == 'uploadImg' ? 'width: 180px;height:140px;margin-right:20px;margin-bottom: 60px;' : 'width: 120px;height:120px;background-position: 50% 30%;margin-right:20px;margin-bottom: 60px;'"
        @click="selectFile"
        v-if="uploadType != 'showFile' && uploadList.length < Number(maxLength)"
      ><p class="Upload_item_upload_text">添加本地文件</p>
      </div>
        <el-button v-if="uploadFilesBtn == true" type="primary" @click="selectFile">上传文件</el-button>
      <div
        v-show="!localFiles && uploadFilesBtn == false"
        :class="disabled ? 'Upload_item_upload Upload_item_upload_disabled' : 'Upload_item_upload' "
        :style="uploadType == 'uploadImg' ? 'width: 180px;height:140px' : 'width: 190px;height:190px'"
        @click="selectFile"
        v-if="uploadType != 'showFile' && uploadList.length < Number(maxLength)"
      >
      </div>
      <div :class="disabled ? 'Upload_item_upload Upload_item_upload_disabled' : 'Upload_item_upload' ">
        <!-- <AddProjectFile ref="AddProjectFileRef" v-if="localFiles" @updateFiles="updateFiles" :uploadType="uploadType" :project_id="project_id" v-model:file_arr="uploadList"></AddProjectFile> -->
      </div>
      <input v-if="!UploadLoading" type="file" title="" ref="fileInputRef" :accept="accept != '' ? accept : (uploadType == 'uploadImg' ?'image/jpeg, image/jpg, image/png' : '')" @change='fileInputChange' style="display:none;" :multiple="maxLength > 1">
    </div>
    <!-- 上传类型为导入时 importProject 展示全屏实时进度 -->
    <div v-show="importProjectLoadingShow" class="importProjectLoading">
      <div class="importProjectLoading_bg"></div>
        <el-progress type="circle" :percentage="parseInt(importProjectPercentage*100)" />
      <div style="margin-top: 20px;">上传中</div>
    </div>
  </div>
</template>
<script>
import {getStorage,setStorage,removeStorage} from '@/service/auth.js';
import { PostData } from "@/api/fetchdata";
import myStorage from '@/service/storage';
import { reactive,toRefs,onMounted, getCurrentInstance, computed, watch} from '@vue/composition-api';
import { initOssClient, upload, partUpload, multipartUpload, abortUpload } from './aliOssUpload';
// import { Delete, Download } from '@element-plus/icons-vue'
// import { Delete } from '@element-plus/icons-vue';
export default {
  name: '',
  props: {
    microservices: {
      type: String,
      default: 'api//oss/accredit/tj',
    },
    oss_url: {
      type: String,
      default: '',
    },
    FileList: { // 绑定的数据
      default: () => {
        return []
      }
    },
    uploadType: { // 组件的类型， 支持 uploadFile(上传图频文件)，uploadImg(上传图片),showFile(仅展示),importProject(上传文件，返回进度和结果，不展示组件)  默认值： uploadFile}
      type: String,
      default: ''
    },
    maxLength: {
      type: [Number, String],
      default: 10,
    },
    maxSize: {
      type: [Number, String],
      default: 1000,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: { // 上传文件类型
      type: String,
      default: ''
    },
    dir: { // 后端存储文件的目录
      type: String,
      default: 'test/'
    },
    localFiles:{
      type: Boolean,
      default: false,
    },
    project_id:{
      type: [String, Number],
      default: ''
    },
    isOcr: { //是否启用ocr识别
      type: [Boolean],
      default: false,
    },
    uploadFilesBtn:{ //是否使用按钮上传
      type: [Boolean],
      default: false,
    }
  },
  // components: {Delete,Download},
  setup(props) {
    const { proxy } = getCurrentInstance(); // 相当于之前的this
    const data = reactive({
      loading: false,
      UploadLoading: false,
      ossDomain: getStorage('oss_domain'),
      client: {},
      fileBack: ['#fe9940','#409dfe','#eb5e5e','#1fbf41','#679bf4'],
      uploadList: [],
      importProjectLoadingShow: false,
      importProjectPercentage: 0,
    });
    const ossInit = async (res)=> { // 初始化oss
      const { client } = await initOssClient(props.microservices);
      data.client = client;
    };
    const ordinaryUpload = async (client, file, checkPoint, index ) => { // 普通上传,为了获取实时进度，采用断点续传
      let pushIndex = (index != 'push') ? index : data.uploadList.length;
      if(index == 'push'){
        if(proxy.uploadFilesBtn === true){
          data.loading = true;
          data.uploadList = [
            {
          url: '', // 上传之后展示的文件
          name: file.name,
          size: file.size,
          type: file.name.slice(Number(file.name.lastIndexOf('.')) + 1, file.name.length),
          progress: 0, // 上传试试进度
          client: client,
          stop: false, // 是否暂停
          file: file, // 上传的原始文件
            }
          ]
        }else{
            data.uploadList.push({
            url: '', // 上传之后展示的文件
            name: file.name,
            size: file.size,
            type: file.name.slice(Number(file.name.lastIndexOf('.')) + 1, file.name.length),
            progress: 0, // 上传试试进度
            client: client,
            stop: false, // 是否暂停
            file: file, // 上传的原始文件
          })
        }
      };
      let url = await multipartUpload(client, file, props.dir,(p,cpt) => {
        data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].checkPoint = cpt;
        data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].progress = p;
        if(props.uploadType == 'importProject') { // 导入文件时返回实时进度
          data.importProjectLoadingShow = true;
          data.importProjectPercentage = p;
        }
      },checkPoint);
      let urlArr = url[0].split('?')[0].split('/');
      let dirUrl = urlArr[urlArr.length - 1];
      data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].url = props.dir + dirUrl;
      if(url){
        delete data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].progress;
        delete data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].client;
        delete data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].stop;
        delete data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].file;
        if(props.uploadType == 'importProject') { // 导入文件时返回实时进度
          proxy.$emit('importProjectUrl', props.dir + dirUrl);
          data.importProjectLoadingShow = false;
          data.importProjectPercentage = 0;
          data.uploadList = [];
        }
      }
      imageOcr(urlArr)
      if(proxy.uploadFilesBtn === true){
        const { client } = await initOssClient(props.microservices);
        proxy.$emit('showUrl',dirUrl, [], client)
        data.loading = false;
      }
    };
    const updateFiles = (files) => {
      files.map(item => {
        data.uploadList.push({
          url:item.url,
          name:item.name,
          type:item.type,
          size:item.size,
          filesName:'delete'
        })
      })
      proxy.$refs.AddProjectFileRef.uploadList = []
    }
    const myPartUpload = async (client, file, checkPoint, index) => {
      let pushIndex = (index != 'push') ? index : data.uploadList.length;
      if(index == 'push'){
        if(proxy.uploadFilesBtn === true){
          data.loading = true;
          data.uploadList = [
            {
          url: '', // 上传之后展示的文件
          name: file.name,
          size: file.size,
          type: file.name.slice(Number(file.name.lastIndexOf('.')) + 1, file.name.length),
          progress: 0, // 上传试试进度
          client: client,
          stop: false, // 是否暂停
          file: file, // 上传的原始文件
            }
          ]
        }else{
            data.uploadList.push({
            url: '', // 上传之后展示的文件
            name: file.name,
            size: file.size,
            type: file.name.slice(Number(file.name.lastIndexOf('.')) + 1, file.name.length),
            progress: 0, // 上传试试进度
            client: client,
            stop: false, // 是否暂停
            file: file, // 上传的原始文件
          })
        }
      };
      let url = await partUpload(client, file, props.dir,(p,cpt) => {
        data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].checkPoint = cpt;
        data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].progress = p;
        if(props.uploadType == 'importProject') { // 导入文件时返回实时进度
          data.importProjectLoadingShow = true;
          data.importProjectPercentage = p;
        }
      },checkPoint);
      let urlArr = url[0].split('?')[0].split('/');
      let dirUrl = urlArr[urlArr.length - 1];
      data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].url = props.dir + dirUrl;
      if(url){
        delete data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].progress;
        delete data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].client;
        delete data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].stop;
        delete data.uploadList[proxy.uploadFilesBtn === true ? pushIndex - pushIndex : pushIndex].file;
        if(props.uploadType == 'importProject') { // 导入文件时返回实时进度
          proxy.$emit('importProjectUrl', props.dir + dirUrl);
          data.importProjectLoadingShow = false;
          data.importProjectPercentage = 0;
          data.uploadList = [];
        }
      };
      imageOcr(urlArr)
      if(proxy.uploadFilesBtn === true){
        const { client } = await initOssClient(props.microservices);
        proxy.$emit('showUrl',dirUrl,data.uploadList, client)
        data.loading = false
      }
    }
    const imageOcr = (url) => { // ocr识别
      if(proxy.isOcr){
      data.loading = true;
      let newUrl = url[url.length - 3] + '/' + url[url.length - 2] + '/' + url[url.length - 1]
      let parameter = {
          microservices: "api/ocr/recognize/business/license",
          object: newUrl,
        };
       PostData(parameter).then((res) => {
          if (res.data.ret === 200) {
            proxy.$emit("ocrIdentify", res.data.data);
          } else {
            proxy.$message.warning('请上传正确的营业执照');
          }
        data.loading = false;
        });
      }
    }
    const stopUpload = (item,index)=> { // 暂停
      item.client.cancel();
      data.uploadList[index].stop = true;
    };
    const continueUpload = async(item,index)=> { // 继续上传
      data.uploadList[index].stop = false;
      ordinaryUpload(item.client, item.file, item.checkPoint, index);
    };
    const selectFile = ()=> { // 选择文件
      if(props.disabled){
        return false
      };
      // 每次选择文件判断一下当前token是否失效
      let ossExpiration = myStorage.getItem(`${props.microservices}_ossExpiration`);
      let time = Date.parse(new Date());
      if(!ossExpiration || ossExpiration <= time){ // 如果当前时间已超时，重新获取osstoken
        // 超时清空ossConfig
        myStorage.clearItem(`${props.microservices}_ossExpiration`);
        ossInit();
      }
      proxy.$refs.fileInputRef.click();
    };
    const fileInputChange = async(event)=> { // 选中的文件
      let fileList = event.target.files; // 上传的文件
      if((fileList.length + data.uploadList.length) > props.maxLength) { // 检验文件数量
        proxy.$message.warning(`文件的最大上传数量不能超过${props.maxLength}个`);
        proxy.$refs.fileInputRef.value = '';
        return false;
      };
      for(let i=0; i<fileList.length; i++){ // 校验文件大小
        if(((fileList[i].size / 1024) / 1024) > props.maxSize) {
          proxy.$message.warning(`文件大小不能超过${props.maxSize}M`);
          proxy.$refs.fileInputRef.value = '';
          return false;
        };
      };
      if (fileList.length) {
        proxy.$emit('start');
        // 判断文件大小,大于5M的切片上传, 由于普通上传不支持实时进度，所以都使用切片上传
        for (let i=0; i<fileList.length; i++) {
          if(fileList[i].size > (1024 * 1024 * 5)) { // 切片上传, 切片大小为1M并发数量5
            const { client } = await initOssClient(props.microservices);
            await myPartUpload(client, fileList[i], {}, 'push');
          } else { // 普通上传
            const { client } = await initOssClient(props.microservices);
            await ordinaryUpload(client, fileList[i], {}, 'push');
          }
        }
        proxy.$refs.fileInputRef.value = '';
        proxy.$emit('finished', data.uploadList);
      }
    };
    const cancelUpload = (item, index)=> { // 取消上传并删除已上传的分片
      // abortUpload(item.client, item.checkPoint.uploadId, item.checkPoint.name);
      item.client.cancel();
      data.uploadList.splice(index, 1);
    };
    const clear = () => {
      data.uploadList = [];
    }
    const deleteItem = (index)=> {
        data.uploadList.splice(index, 1)
    };
    onMounted(()=> {
      data.uploadList = props.FileList;
      if (props.oss_url) {
        data.ossDomain = props.oss_url;
      }
    });
    watch(
      [() => props.FileList],
      (newValue, oldValue) => {
        if(newValue[0]){
          data.uploadList = newValue[0];
        }
      },
      { immediate: true }
    );
    const uploadListShow = computed(() => {
      let list = [];
      data.uploadList.map(item => {
        if(/\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url)){
          list.push(data.ossDomain+item.url);
        }
      })
      return list;
    });
    return {
      ...toRefs(data),
      selectFile,
      fileInputChange,
      stopUpload,
      continueUpload,
      cancelUpload,
      deleteItem,
      clear,
      uploadListShow,
      updateFiles
    };
  }
}
</script>
<style lang='scss'>
.Upload{
  width: 100%;
  overflow: hidden;
  .Upload_item{
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    .Upload_item_main{
      background: #FFFFFF;
      border: 1px solid #E1E1E1;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;
      :deep(.el-progress-circle){
        width: auto !important;
        height: auto !important;
      }
      i{
        font-size: 26px;
        color: white;
      }
      .Upload_item_img{
        width: 100%;
        height: 100%;
      }
      .Upload_item_button_wrapper{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: none;
        .Upload_item_button{
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      &:hover .Upload_item_button_wrapper{
        display: block;
      }
      .Upload_item_delbutton_wrapper{
        position: absolute;
        top: 0;
        right: 0;
        display: none;
      }
      .Upload_item_dowbutton_wrapper{
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }
      &:hover .Upload_item_delbutton_wrapper{
        display: block;
      }
      &:hover .Upload_item_dowbutton_wrapper{
        display: block;
      }
      .l_UploadImages_file_file_icon{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 100px;
        color: #FFFFFF;
      }
    }
    .Upload_item_footer{
      width: 100%;
      height: 20px;
      margin-top: 10px;
      font-size: 12px;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .Upload_item_upload{
    background: #FFFFFF;
    border: 1px solid #E1E1E1;
    float: left;
    background-image: url('../../assets/add_default.png');
    background-repeat: no-repeat;
    background-size: 40px 40px;
    background-position: 50% 50%;
    position: relative;
    cursor: pointer;
    &:hover{
      background-color: #F7F7F7;
    }
    .Upload_item_upload_text{
      position: absolute;
      top: 70px;
      left: 18px;
    }
  }
  .Upload_item_upload_disabled{
    cursor: no-drop;
  }
}
.importProjectLoading{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .importProjectLoading_bg{
    background-color: rgba(0,0,0,0.3);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UploadPanel/index.vue